<template>
    <div class="modal fade show billing-detail-modal" aria-labelledby="addNewCardTitle">
        <div class="modal-dialog modal-dialog-centered modal-lg" ref="admissionModalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between align-items-center px-1 my-1 align-item-center">
                            <h1 class="mb-0">Billing Details</h1>
                            <button @click="closeModal" type="button" class="btn-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0">
                
                <div class="modal-body">

                    <div class="table-container">
                        <table class="table create-billing table-width">
                            <thead>
                                <tr>
                                    <th class=" pl-10 particular">Item Details</th>
                                    <th>Service Resource</th>
                                    <th>Schedule</th>
                                    <th class="qty">Qty</th>
                                    <th class="rate">Rate</th>
                                    <th class="sub-amount">Amount</th>
                                    <th class="discount">Dis(%)</th>
                                    <th class="d-amount">Dis</th>
                                    <th class="after-amount">After Discount</th>
                                    <th class="total">Total Amount</th>
                                </tr>
                            </thead>

                            <tbody ref="tableRef">
                                <tr v-for="(item, index) in tableItems" :key="index">
                                    <td class="pl-10">
                                        <div class="col">
                                            <strong>{{ item.name }}</strong>
                                        </div>
                                    </td>
                                    <td class="text-center">{{ item.service_resource ? item.service_resource.name : '' }}</td>
                                    <td class="text-center">{{ item.schedule_date ? formatDate(new Date(item.schedule_date)) : '' }}</td>
                                    <td class="text-center">{{ item.quantity }}</td>
                                    <td class="text-center">{{ item.rate }}</td>
                                    <td class="text-center">{{ item.amount }}</td>
                                    <td class="text-center">{{ item.discount_percent }}%</td>
                                    <td class="text-center">{{ item.discount_amount }}</td>
                                    <td class="text-center">{{ item.discount_amount }}</td>
                                    <td class="text-center">{{ item.total_amount }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { formatDate } from '@/services/utils/global.js';

const props = defineProps({
    isShowBillingDetail: {
        type: Boolean,
        default: false
    },
    tableItems: {
        type: Object,
        default: () => {}
    }
});

const emit = defineEmits(['update:isShowBillingDetail']);

const closeModal = () => {
    emit('update:isShowBillingDetail', false);
}
</script>


<style scoped>

.modal-body{
    min-height: 400px;
}
.bg {
    background: aliceblue !important;
}
.modal-card{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    max-height: 280px;
    overflow-x: hidden;
    overflow-y: scroll;
}
.billing-detail-modal {
    display: block; 
    background: #1c1d1c33
}
.card-height{
  min-height: 200px
}

.create-billing > :not(caption) > * > * {
  padding: 0.72rem 0.2rem;
}

.create-billing th {
  text-align: left;
  width: 30%;
  font-weight: 600;
}

.create-billing td {
  text-align: left;
}
</style>